/**
 * Video Reels Carousel
 * ---------------------
 * Alpine.js data component + IntersectionObserver autoplay.
 * Uses Splide (already bundled in the theme).
 */
document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Theme_ReelsCarousel',
    ({
      sectionId = '',
      perPageDesktop = 4,
      perPageTablet = 3,
      gap = 12,
      autoplayVideos = true,
      muteVideos = true,
      loopVideos = true,
      showArrows = true,
      showPagination = false,
    }) => ({
      splide: null,

      init() {
        this.$nextTick(() => {
          this._initSplide();
          if (autoplayVideos) this._initAutoplay();
        });

        /* Hot-reload support for dev */
        document.addEventListener('dev:hotreloadmutation', async () => {
          if (!Shopify.designMode) {
            if (this.splide) this.splide.destroy();
            await this.$nextTick();
            this._initSplide();
            if (autoplayVideos) this._initAutoplay();
          }
        });
      },

      /* ————— Splide ————— */
      _initSplide() {
        if (typeof Splide === 'undefined') {
          console.error('video-reels-carousel.js requires Splide');
          return;
        }

        const el = this.$root;

        this.splide = new Splide(el, {
          type: 'slide',
          rewind: true,
          perPage: perPageDesktop,
          perMove: 1,
          gap: `${gap}px`,
          arrows: showArrows,
          pagination: showPagination,
          speed: 500,
          drag: true,
          snap: true,
          flickPower: 300,
          autoplay: true,
          interval: 4000,
          pauseOnHover: true,
          pauseOnFocus: false,
          resetProgress: false,
          mediaQuery: 'max',
          breakpoints: {
            1024: { perPage: perPageTablet, gap: `${gap}px` },
            640:  { perPage: 2, gap: `${Math.round(gap * 0.75)}px` },
            480:  { perPage: 1, gap: `${Math.round(gap * 0.5)}px`, padding: { right: '15%' } },
          },
        });

        this.splide.mount();
      },

      /* ————— IntersectionObserver autoplay ————— */
      _initAutoplay() {
        const videos = this.$root.querySelectorAll('video[data-autoplay-on-visible]');
        if (!videos.length) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );

        videos.forEach((v) => observer.observe(v));
      },

      /* ————— Play / Pause toggle ————— */
      togglePlay(event) {
        const btn = event.currentTarget;
        const card = btn.closest('.reels-card');
        const video = card?.querySelector('video');
        if (!video) return;

        if (video.paused) {
          video.play().catch(() => {});
          btn.setAttribute('data-playing', 'true');
        } else {
          video.pause();
          btn.setAttribute('data-playing', 'false');
        }
      },

      /* ————— Mute / Unmute toggle ————— */
      toggleMute(event) {
        const btn = event.currentTarget;
        const card = btn.closest('.reels-card');
        const video = card?.querySelector('video');
        if (!video) return;

        video.muted = !video.muted;
        btn.setAttribute('data-muted', video.muted ? 'true' : 'false');
      },
    })
  );
});
